<div [ngClass]="{ 'subscription-bar-visible': subscriptionStatusBarVisible() }" class="d-flex flex-column flex-root">
  @switch (theme) {
    @case ('default') {
      <default-layout></default-layout>
    }
    @case ('theme2') {
      <theme2-layout></theme2-layout>
    }
    @case ('theme3') {
      <theme3-layout></theme3-layout>
    }
    @case ('theme4') {
      <theme4-layout></theme4-layout>
    }
    @case ('theme5') {
      <theme5-layout></theme5-layout>
    }
    @case ('theme6') {
      <theme6-layout></theme6-layout>
    }
    @case ('theme7') {
      <theme7-layout></theme7-layout>
    }
    @case ('theme8') {
      <theme8-layout class="d-flex flex-column flex-row-fluid"></theme8-layout>
    }
    @case ('theme9') {
      <theme9-layout></theme9-layout>
    }
    @case ('theme10') {
      <theme10-layout class="d-flex flex-column flex-row-fluid"></theme10-layout>
    }
    @case ('theme11') {
      <theme11-layout></theme11-layout>
    }
    @case ('theme12') {
      <theme12-layout class="d-flex flex-column flex-row-fluid"></theme12-layout>
    }
  }
</div>

<kt-scroll-top></kt-scroll-top>

@if (!installationMode) {
  <linkedAccountsModal
    #linkedAccountsModal
    (modalClose)="getRecentlyLinkedUsers()"
  ></linkedAccountsModal>
}
<userDelegationsModal #userDelegationsModal></userDelegationsModal>
<changePasswordModal #changePasswordModal></changePasswordModal>
<changeProfilePictureModal #changeProfilePictureModal></changeProfilePictureModal>
<mySettingsModal #mySettingsModal (modalSave)="onMySettingsModalSaved()"></mySettingsModal>
<notificationSettingsModal #notificationSettingsModal></notificationSettingsModal>

@if (IsSessionTimeOutEnabled) {
  <session-timeout #sessionTimeout></session-timeout>
}
